
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/tariffs",
      function () {
        return require("private-next-pages/[locale]/tariffs.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/tariffs"])
      });
    }
  